import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { ReglaPerfilamiento } from '../../models/tipo-novedad.model';

export interface TipoNovedadDTO {
  id?: number;
  idTipoNovedad: number;
  tipoNovedad: string;
  /** Algunos entornos envían PascalCase */
  TipoNovedad?: string;
  aplicaContratoTransitorio: number | boolean;
  estado: number | string | boolean | null;
  codigoTipoNovedad?: string;
  /** Enlazado en `TRL_P_TIPO_NOVEDAD_TIPO_SOLICITUD`; usado en documentos-parametrizados y radicación. */
  idTipoSolicitud?: number | null;
  IdTipoSolicitud?: number | null;
}

/** Query GET `tipos-novedad` / `subtipos-novedad` (MP-FT-1358 + contrato backend). */
export interface CatalogoTiposNovedadQuery {
  /**
   * Si se envía, el backend limita a tipos enlazados en TRL_P_TIPO_NOVEDAD_TIPO_SOLICITUD.
   * Sin este campo (p. ej. `environment.TIPOS_NOVEDAD_LISTAR_SIN_FILTRO_TIPO_SOLICITUD`), devuelve activos sin ese filtro.
   */
  idTipoSolicitud?: number;
  /** `true` solo si el contrato está en ACTIVO, TRANSITORIO (filtra `aplicaContratoTransitorio`). */
  contratoTransitorio: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TiposNovedadService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.TIPOS_NOVEDAD}`;
  private reglasUrl = `${ENV.HOST}${URL_MAP.API.REGLAS_PERFILAMIENTO_TIPO_NOVEDAD}`;

  constructor(private http: HttpClient) {}

  getTiposNovedad(
    query: CatalogoTiposNovedadQuery,
  ): Observable<TipoNovedadDTO[]> {
    let params = new HttpParams().set(
      'contratoTransitorio',
      query.contratoTransitorio ? 'true' : 'false',
    );
    const id = query.idTipoSolicitud;
    if (id != null && Number.isFinite(Number(id))) {
      params = params.set('idTipoSolicitud', String(id));
    }
    return this.http.get<TipoNovedadDTO[]>(this.apiUrl, { params });
  }

  /**
   * Reglas UI (flags). `prm_id_tipo_novedad` numérico = PK catálogo.
   */
  getReglasPerfilamiento(
    idTipoNovedad: number | string,
  ): Observable<ReglaPerfilamiento[]> {
    const id = Number(String(idTipoNovedad).trim());
    const body = {
      jsonParametros: JSON.stringify({
        prm_id_tipo_novedad: Number.isFinite(id) ? id : idTipoNovedad,
      }),
    };
    return this.http.post<ReglaPerfilamiento[]>(this.reglasUrl, body);
  }
}
